(function (f) {
  if (typeof exports === "object" && typeof module !== "undefined") {
    module.exports = f();
  } else if (typeof define === "function" && define.amd) {
    define([], f);
  } else {
    var g;
    if (typeof window !== "undefined") {
      g = window;
    } else if (typeof global !== "undefined") {
      g = global;
    } else if (typeof self !== "undefined") {
      g = self;
    } else {
      g = this;
    }
    g.Polyglot = f();
  }
})(function () {
  var define, module, exports;
  return (function e(t, n, r) {
    function s(o, u) {
      if (!n[o]) {
        if (!t[o]) {
          var a = typeof require == "function" && require;
          if (!u && a) return a(o, !0);
          if (i) return i(o, !0);
          var f = new Error("Cannot find module '" + o + "'");
          throw ((f.code = "MODULE_NOT_FOUND"), f);
        }
        var l = (n[o] = { exports: {} });
        t[o][0].call(
          l.exports,
          function (e) {
            var n = t[o][1][e];
            return s(n ? n : e);
          },
          l,
          l.exports,
          e,
          t,
          n,
          r
        );
      }
      return n[o].exports;
    }
    var i = typeof require == "function" && require;
    for (var o = 0; o < r.length; o++) s(r[o]);
    return s;
  })(
    {
      1: [
        function (require, module, exports) {
          // shim for using process in browser
          var process = (module.exports = {});

          // cached from whatever global is present so that test runners that stub it
          // don't break things.  But we need to wrap it in a try catch in case it is
          // wrapped in strict mode code which doesn't define any globals.  It's inside a
          // function because try/catches deoptimize in certain engines.

          var cachedSetTimeout;
          var cachedClearTimeout;

          function defaultSetTimout() {
            throw new Error("setTimeout has not been defined");
          }
          function defaultClearTimeout() {
            throw new Error("clearTimeout has not been defined");
          }
          (function () {
            try {
              if (typeof setTimeout === "function") {
                cachedSetTimeout = setTimeout;
              } else {
                cachedSetTimeout = defaultSetTimout;
              }
            } catch (e) {
              cachedSetTimeout = defaultSetTimout;
            }
            try {
              if (typeof clearTimeout === "function") {
                cachedClearTimeout = clearTimeout;
              } else {
                cachedClearTimeout = defaultClearTimeout;
              }
            } catch (e) {
              cachedClearTimeout = defaultClearTimeout;
            }
          })();
          function runTimeout(fun) {
            if (cachedSetTimeout === setTimeout) {
              //normal enviroments in sane situations
              return setTimeout(fun, 0);
            }
            // if setTimeout wasn't available but was latter defined
            if (
              (cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) &&
              setTimeout
            ) {
              cachedSetTimeout = setTimeout;
              return setTimeout(fun, 0);
            }
            try {
              // when when somebody has screwed with setTimeout but no I.E. maddness
              return cachedSetTimeout(fun, 0);
            } catch (e) {
              try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                return cachedSetTimeout.call(null, fun, 0);
              } catch (e) {
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                return cachedSetTimeout.call(this, fun, 0);
              }
            }
          }
          function runClearTimeout(marker) {
            if (cachedClearTimeout === clearTimeout) {
              //normal enviroments in sane situations
              return clearTimeout(marker);
            }
            // if clearTimeout wasn't available but was latter defined
            if (
              (cachedClearTimeout === defaultClearTimeout ||
                !cachedClearTimeout) &&
              clearTimeout
            ) {
              cachedClearTimeout = clearTimeout;
              return clearTimeout(marker);
            }
            try {
              // when when somebody has screwed with setTimeout but no I.E. maddness
              return cachedClearTimeout(marker);
            } catch (e) {
              try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                return cachedClearTimeout.call(null, marker);
              } catch (e) {
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                return cachedClearTimeout.call(this, marker);
              }
            }
          }
          var queue = [];
          var draining = false;
          var currentQueue;
          var queueIndex = -1;

          function cleanUpNextTick() {
            if (!draining || !currentQueue) {
              return;
            }
            draining = false;
            if (currentQueue.length) {
              queue = currentQueue.concat(queue);
            } else {
              queueIndex = -1;
            }
            if (queue.length) {
              drainQueue();
            }
          }

          function drainQueue() {
            if (draining) {
              return;
            }
            var timeout = runTimeout(cleanUpNextTick);
            draining = true;

            var len = queue.length;
            while (len) {
              currentQueue = queue;
              queue = [];
              while (++queueIndex < len) {
                if (currentQueue) {
                  currentQueue[queueIndex].run();
                }
              }
              queueIndex = -1;
              len = queue.length;
            }
            currentQueue = null;
            draining = false;
            runClearTimeout(timeout);
          }

          process.nextTick = function (fun) {
            var args = new Array(arguments.length - 1);
            if (arguments.length > 1) {
              for (var i = 1; i < arguments.length; i++) {
                args[i - 1] = arguments[i];
              }
            }
            queue.push(new Item(fun, args));
            if (queue.length === 1 && !draining) {
              runTimeout(drainQueue);
            }
          };

          // v8 likes predictible objects
          function Item(fun, array) {
            this.fun = fun;
            this.array = array;
          }
          Item.prototype.run = function () {
            this.fun.apply(null, this.array);
          };
          process.title = "browser";
          process.browser = true;
          process.env = {};
          process.argv = [];
          process.version = ""; // empty string to avoid regexp issues
          process.versions = {};

          function noop() {}

          process.on = noop;
          process.addListener = noop;
          process.once = noop;
          process.off = noop;
          process.removeListener = noop;
          process.removeAllListeners = noop;
          process.emit = noop;
          process.prependListener = noop;
          process.prependOnceListener = noop;

          process.listeners = function (name) {
            return [];
          };

          process.binding = function (name) {
            throw new Error("process.binding is not supported");
          };

          process.cwd = function () {
            return "/";
          };
          process.chdir = function (dir) {
            throw new Error("process.chdir is not supported");
          };
          process.umask = function () {
            return 0;
          };
        },
        {},
      ],
      2: [
        function (require, module, exports) {
          //     (c) 2012-2016 Airbnb, Inc.
          //
          //     polyglot.js may be freely distributed under the terms of the BSD
          //     license. For all licensing information, details, and documention:
          //     http://airbnb.github.com/polyglot.js
          //
          //
          // Polyglot.js is an I18n helper library written in JavaScript, made to
          // work both in the browser and in Node. It provides a simple solution for
          // interpolation and pluralization, based off of Airbnb's
          // experience adding I18n functionality to its Backbone.js and Node apps.
          //
          // Polylglot is agnostic to your translation backend. It doesn't perform any
          // translation; it simply gives you a way to manage translated phrases from
          // your client- or server-side JavaScript application.
          //

          "use strict";

          var forEach = require("for-each");
          var warning = require("warning");
          var has = require("has");
          var trim = require("string.prototype.trim");

          var warn = function warn(message) {
            warning(false, message);
          };

          var replace = String.prototype.replace;
          var split = String.prototype.split;

          // #### Pluralization methods
          // The string that separates the different phrase possibilities.
          var delimeter = "||||";

          // Mapping from pluralization group plural logic.
          var pluralTypes = {
            arabic: function (n) {
              // http://www.arabeyes.org/Plural_Forms
              if (n < 3) {
                return n;
              }
              if (n % 100 >= 3 && n % 100 <= 10) return 3;
              return n % 100 >= 11 ? 4 : 5;
            },
            german: function (n) {
              return n !== 1 ? 1 : 0;
            },
            french: function (n) {
              return n > 1 ? 1 : 0;
            },
            russian: function (n) {
              if (n % 10 === 1 && n % 100 !== 11) {
                return 0;
              }
              return n % 10 >= 2 &&
                n % 10 <= 4 &&
                (n % 100 < 10 || n % 100 >= 20)
                ? 1
                : 2;
            },
            czech: function (n) {
              if (n === 1) {
                return 0;
              }
              return n >= 2 && n <= 4 ? 1 : 2;
            },
            polish: function (n) {
              if (n === 1) {
                return 0;
              }
              return n % 10 >= 2 &&
                n % 10 <= 4 &&
                (n % 100 < 10 || n % 100 >= 20)
                ? 1
                : 2;
            },
            icelandic: function (n) {
              return n % 10 !== 1 || n % 100 === 11 ? 1 : 0;
            },
          };

          // Mapping from pluralization group to individual locales.
          var pluralTypeToLanguages = {
            arabic: ["ar"],
            german: [
              "da",
              "de",
              "en",
              "es",
              "fi",
              "el",
              "he",
              "hu",
              "it",
              "nl",
              "no",
              "pt",
              "sv",
            ],
            french: ["fr", "tl", "pt-br"],
            russian: ["hr", "ru", "lt"],
            czech: ["cs", "sk"],
            polish: ["pl"],
            icelandic: ["is"],
          };

          function langToTypeMap(mapping) {
            var ret = {};
            forEach(mapping, function (langs, type) {
              forEach(langs, function (lang) {
                ret[lang] = type;
              });
            });
            return ret;
          }

          function pluralTypeName(locale) {
            var langToPluralType = langToTypeMap(pluralTypeToLanguages);
            return (
              langToPluralType[locale] ||
              langToPluralType[split.call(locale, /-/, 1)[0]] ||
              langToPluralType.en
            );
          }

          function pluralTypeIndex(locale, count) {
            return pluralTypes[pluralTypeName(locale)](count);
          }

          var dollarRegex = /\$/g;
          var dollarBillsYall = "$$";
          var tokenRegex = /%\{(.*?)\}/g;

          // ### transformPhrase(phrase, substitutions, locale)
          //
          // Takes a phrase string and transforms it by choosing the correct
          // plural form and interpolating it.
          //
          //     transformPhrase('Hello, %{name}!', {name: 'Spike'});
          //     // "Hello, Spike!"
          //
          // The correct plural form is selected if substitutions.smart_count
          // is set. You can pass in a number instead of an Object as `substitutions`
          // as a shortcut for `smart_count`.
          //
          //     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 1}, 'en');
          //     // "1 new message"
          //
          //     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 2}, 'en');
          //     // "2 new messages"
          //
          //     transformPhrase('%{smart_count} new messages |||| 1 new message', 5, 'en');
          //     // "5 new messages"
          //
          // You should pass in a third argument, the locale, to specify the correct plural type.
          // It defaults to `'en'` with 2 plural forms.
          function transformPhrase(phrase, substitutions, locale) {
            if (typeof phrase !== "string") {
              throw new TypeError(
                "Polyglot.transformPhrase expects argument #1 to be string"
              );
            }

            if (substitutions == null) {
              return phrase;
            }

            var result = phrase;

            // allow number as a pluralization shortcut
            var options =
              typeof substitutions === "number"
                ? { smart_count: substitutions }
                : substitutions;

            // Select plural form: based on a phrase text that contains `n`
            // plural forms separated by `delimeter`, a `locale`, and a `substitutions.smart_count`,
            // choose the correct plural form. This is only done if `count` is set.
            if (options.smart_count != null && result) {
              var texts = split.call(result, delimeter);
              result = trim(
                texts[pluralTypeIndex(locale || "en", options.smart_count)] ||
                  texts[0]
              );
            }

            // Interpolate: Creates a `RegExp` object for each interpolation placeholder.
            result = replace.call(
              result,
              tokenRegex,
              function (expression, argument) {
                if (!has(options, argument) || options[argument] == null) {
                  return expression;
                }
                // Ensure replacement value is escaped to prevent special $-prefixed regex replace tokens.
                return replace.call(
                  options[argument],
                  dollarRegex,
                  dollarBillsYall
                );
              }
            );

            return result;
          }

          // ### Polyglot class constructor
          function Polyglot(options) {
            var opts = options || {};
            this.phrases = {};
            this.extend(opts.phrases || {});
            this.currentLocale = opts.locale || "en";
            this.allowMissing = !!opts.allowMissing;
            this.warn = opts.warn || warn;
          }

          // ### polyglot.locale([locale])
          //
          // Get or set locale. Internally, Polyglot only uses locale for pluralization.
          Polyglot.prototype.locale = function (newLocale) {
            if (newLocale) this.currentLocale = newLocale;
            return this.currentLocale;
          };

          // ### polyglot.extend(phrases)
          //
          // Use `extend` to tell Polyglot how to translate a given key.
          //
          //     polyglot.extend({
          //       "hello": "Hello",
          //       "hello_name": "Hello, %{name}"
          //     });
          //
          // The key can be any string.  Feel free to call `extend` multiple times;
          // it will override any phrases with the same key, but leave existing phrases
          // untouched.
          //
          // It is also possible to pass nested phrase objects, which get flattened
          // into an object with the nested keys concatenated using dot notation.
          //
          //     polyglot.extend({
          //       "nav": {
          //         "hello": "Hello",
          //         "hello_name": "Hello, %{name}",
          //         "sidebar": {
          //           "welcome": "Welcome"
          //         }
          //       }
          //     });
          //
          //     console.log(polyglot.phrases);
          //     // {
          //     //   'nav.hello': 'Hello',
          //     //   'nav.hello_name': 'Hello, %{name}',
          //     //   'nav.sidebar.welcome': 'Welcome'
          //     // }
          //
          // `extend` accepts an optional second argument, `prefix`, which can be used
          // to prefix every key in the phrases object with some string, using dot
          // notation.
          //
          //     polyglot.extend({
          //       "hello": "Hello",
          //       "hello_name": "Hello, %{name}"
          //     }, "nav");
          //
          //     console.log(polyglot.phrases);
          //     // {
          //     //   'nav.hello': 'Hello',
          //     //   'nav.hello_name': 'Hello, %{name}'
          //     // }
          //
          // This feature is used internally to support nested phrase objects.
          Polyglot.prototype.extend = function (morePhrases, prefix) {
            forEach(
              morePhrases,
              function (phrase, key) {
                var prefixedKey = prefix ? prefix + "." + key : key;
                if (typeof phrase === "object") {
                  this.extend(phrase, prefixedKey);
                } else {
                  this.phrases[prefixedKey] = phrase;
                }
              },
              this
            );
          };

          // ### polyglot.unset(phrases)
          // Use `unset` to selectively remove keys from a polyglot instance.
          //
          //     polyglot.unset("some_key");
          //     polyglot.unset({
          //       "hello": "Hello",
          //       "hello_name": "Hello, %{name}"
          //     });
          //
          // The unset method can take either a string (for the key), or an object hash with
          // the keys that you would like to unset.
          Polyglot.prototype.unset = function (morePhrases, prefix) {
            if (typeof morePhrases === "string") {
              delete this.phrases[morePhrases];
            } else {
              forEach(
                morePhrases,
                function (phrase, key) {
                  var prefixedKey = prefix ? prefix + "." + key : key;
                  if (typeof phrase === "object") {
                    this.unset(phrase, prefixedKey);
                  } else {
                    delete this.phrases[prefixedKey];
                  }
                },
                this
              );
            }
          };

          // ### polyglot.clear()
          //
          // Clears all phrases. Useful for special cases, such as freeing
          // up memory if you have lots of phrases but no longer need to
          // perform any translation. Also used internally by `replace`.
          Polyglot.prototype.clear = function () {
            this.phrases = {};
          };

          // ### polyglot.replace(phrases)
          //
          // Completely replace the existing phrases with a new set of phrases.
          // Normally, just use `extend` to add more phrases, but under certain
          // circumstances, you may want to make sure no old phrases are lying around.
          Polyglot.prototype.replace = function (newPhrases) {
            this.clear();
            this.extend(newPhrases);
          };

          // ### polyglot.t(key, options)
          //
          // The most-used method. Provide a key, and `t` will return the
          // phrase.
          //
          //     polyglot.t("hello");
          //     => "Hello"
          //
          // The phrase value is provided first by a call to `polyglot.extend()` or
          // `polyglot.replace()`.
          //
          // Pass in an object as the second argument to perform interpolation.
          //
          //     polyglot.t("hello_name", {name: "Spike"});
          //     => "Hello, Spike"
          //
          // If you like, you can provide a default value in case the phrase is missing.
          // Use the special option key "_" to specify a default.
          //
          //     polyglot.t("i_like_to_write_in_language", {
          //       _: "I like to write in %{language}.",
          //       language: "JavaScript"
          //     });
          //     => "I like to write in JavaScript."
          //
          Polyglot.prototype.t = function (key, options) {
            var phrase, result;
            var opts = options == null ? {} : options;
            if (typeof this.phrases[key] === "string") {
              phrase = this.phrases[key];
            } else if (typeof opts._ === "string") {
              phrase = opts._;
            } else if (this.allowMissing) {
              phrase = key;
            } else {
              this.warn('Missing translation for key: "' + key + '"');
              result = key;
            }
            if (typeof phrase === "string") {
              result = transformPhrase(phrase, opts, this.currentLocale);
            }
            return result;
          };

          // ### polyglot.has(key)
          //
          // Check if polyglot has a translation for given key
          Polyglot.prototype.has = function (key) {
            return has(this.phrases, key);
          };

          // export transformPhrase
          Polyglot.transformPhrase = transformPhrase;

          module.exports = Polyglot;
        },
        { "for-each": 3, has: 7, "string.prototype.trim": 9, warning: 26 },
      ],
      3: [
        function (require, module, exports) {
          var isFunction = require("is-function");

          module.exports = forEach;

          var toString = Object.prototype.toString;
          var hasOwnProperty = Object.prototype.hasOwnProperty;

          function forEach(list, iterator, context) {
            if (!isFunction(iterator)) {
              throw new TypeError("iterator must be a function");
            }

            if (arguments.length < 3) {
              context = this;
            }

            if (toString.call(list) === "[object Array]")
              forEachArray(list, iterator, context);
            else if (typeof list === "string")
              forEachString(list, iterator, context);
            else forEachObject(list, iterator, context);
          }

          function forEachArray(array, iterator, context) {
            for (var i = 0, len = array.length; i < len; i++) {
              if (hasOwnProperty.call(array, i)) {
                iterator.call(context, array[i], i, array);
              }
            }
          }

          function forEachString(string, iterator, context) {
            for (var i = 0, len = string.length; i < len; i++) {
              // no such thing as a sparse string.
              iterator.call(context, string.charAt(i), i, string);
            }
          }

          function forEachObject(object, iterator, context) {
            for (var k in object) {
              if (hasOwnProperty.call(object, k)) {
                iterator.call(context, object[k], k, object);
              }
            }
          }
        },
        { "is-function": 4 },
      ],
      4: [
        function (require, module, exports) {
          module.exports = isFunction;

          var toString = Object.prototype.toString;

          function isFunction(fn) {
            var string = toString.call(fn);
            return (
              string === "[object Function]" ||
              (typeof fn === "function" && string !== "[object RegExp]") ||
              (typeof window !== "undefined" &&
                // IE8 and below
                (fn === window.setTimeout ||
                  fn === window.alert ||
                  fn === window.confirm ||
                  fn === window.prompt))
            );
          }
        },
        {},
      ],
      5: [
        function (require, module, exports) {
          var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
          var slice = Array.prototype.slice;
          var toStr = Object.prototype.toString;
          var funcType = "[object Function]";

          module.exports = function bind(that) {
            var target = this;
            if (
              typeof target !== "function" ||
              toStr.call(target) !== funcType
            ) {
              throw new TypeError(ERROR_MESSAGE + target);
            }
            var args = slice.call(arguments, 1);

            var bound;
            var binder = function () {
              if (this instanceof bound) {
                var result = target.apply(
                  this,
                  args.concat(slice.call(arguments))
                );
                if (Object(result) === result) {
                  return result;
                }
                return this;
              } else {
                return target.apply(that, args.concat(slice.call(arguments)));
              }
            };

            var boundLength = Math.max(0, target.length - args.length);
            var boundArgs = [];
            for (var i = 0; i < boundLength; i++) {
              boundArgs.push("$" + i);
            }

            bound = Function(
              "binder",
              "return function (" +
                boundArgs.join(",") +
                "){ return binder.apply(this,arguments); }"
            )(binder);

            if (target.prototype) {
              var Empty = function Empty() {};
              Empty.prototype = target.prototype;
              bound.prototype = new Empty();
              Empty.prototype = null;
            }

            return bound;
          };
        },
        {},
      ],
      6: [
        function (require, module, exports) {
          var implementation = require("./implementation");

          module.exports = Function.prototype.bind || implementation;
        },
        { "./implementation": 5 },
      ],
      7: [
        function (require, module, exports) {
          var bind = require("function-bind");

          module.exports = bind.call(
            Function.call,
            Object.prototype.hasOwnProperty
          );
        },
        { "function-bind": 6 },
      ],
      8: [
        function (require, module, exports) {
          "use strict";

          var bind = require("function-bind");
          var ES = require("es-abstract/es5");
          var replace = bind.call(Function.call, String.prototype.replace);

          var leftWhitespace =
            /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
          var rightWhitespace =
            /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;

          module.exports = function trim() {
            var S = ES.ToString(ES.CheckObjectCoercible(this));
            return replace(replace(S, leftWhitespace, ""), rightWhitespace, "");
          };
        },
        { "es-abstract/es5": 14, "function-bind": 23 },
      ],
      9: [
        function (require, module, exports) {
          "use strict";

          var bind = require("function-bind");
          var define = require("define-properties");

          var implementation = require("./implementation");
          var getPolyfill = require("./polyfill");
          var shim = require("./shim");

          var boundTrim = bind.call(Function.call, getPolyfill());

          define(boundTrim, {
            getPolyfill: getPolyfill,
            implementation: implementation,
            shim: shim,
          });

          module.exports = boundTrim;
        },
        {
          "./implementation": 8,
          "./polyfill": 24,
          "./shim": 25,
          "define-properties": 10,
          "function-bind": 23,
        },
      ],
      10: [
        function (require, module, exports) {
          "use strict";

          var keys = require("object-keys");
          var foreach = require("foreach");
          var hasSymbols =
            typeof Symbol === "function" && typeof Symbol() === "symbol";

          var toStr = Object.prototype.toString;

          var isFunction = function (fn) {
            return (
              typeof fn === "function" && toStr.call(fn) === "[object Function]"
            );
          };

          var arePropertyDescriptorsSupported = function () {
            var obj = {};
            try {
              Object.defineProperty(obj, "x", {
                enumerable: false,
                value: obj,
              });
              /* eslint-disable no-unused-vars, no-restricted-syntax */
              for (var _ in obj) {
                return false;
              }
              /* eslint-enable no-unused-vars, no-restricted-syntax */
              return obj.x === obj;
            } catch (e) {
              /* this is IE 8. */
              return false;
            }
          };
          var supportsDescriptors =
            Object.defineProperty && arePropertyDescriptorsSupported();

          var defineProperty = function (object, name, value, predicate) {
            if (name in object && (!isFunction(predicate) || !predicate())) {
              return;
            }
            if (supportsDescriptors) {
              Object.defineProperty(object, name, {
                configurable: true,
                enumerable: false,
                value: value,
                writable: true,
              });
            } else {
              object[name] = value;
            }
          };

          var defineProperties = function (object, map) {
            var predicates = arguments.length > 2 ? arguments[2] : {};
            var props = keys(map);
            if (hasSymbols) {
              props = props.concat(Object.getOwnPropertySymbols(map));
            }
            foreach(props, function (name) {
              defineProperty(object, name, map[name], predicates[name]);
            });
          };

          defineProperties.supportsDescriptors = !!supportsDescriptors;

          module.exports = defineProperties;
        },
        { foreach: 11, "object-keys": 12 },
      ],
      11: [
        function (require, module, exports) {
          var hasOwn = Object.prototype.hasOwnProperty;
          var toString = Object.prototype.toString;

          module.exports = function forEach(obj, fn, ctx) {
            if (toString.call(fn) !== "[object Function]") {
              throw new TypeError("iterator must be a function");
            }
            var l = obj.length;
            if (l === +l) {
              for (var i = 0; i < l; i++) {
                fn.call(ctx, obj[i], i, obj);
              }
            } else {
              for (var k in obj) {
                if (hasOwn.call(obj, k)) {
                  fn.call(ctx, obj[k], k, obj);
                }
              }
            }
          };
        },
        {},
      ],
      12: [
        function (require, module, exports) {
          "use strict";

          // modified from https://github.com/es-shims/es5-shim
          var has = Object.prototype.hasOwnProperty;
          var toStr = Object.prototype.toString;
          var slice = Array.prototype.slice;
          var isArgs = require("./isArguments");
          var isEnumerable = Object.prototype.propertyIsEnumerable;
          var hasDontEnumBug = !isEnumerable.call(
            { toString: null },
            "toString"
          );
          var hasProtoEnumBug = isEnumerable.call(function () {}, "prototype");
          var dontEnums = [
            "toString",
            "toLocaleString",
            "valueOf",
            "hasOwnProperty",
            "isPrototypeOf",
            "propertyIsEnumerable",
            "constructor",
          ];
          var equalsConstructorPrototype = function (o) {
            var ctor = o.constructor;
            return ctor && ctor.prototype === o;
          };
          var excludedKeys = {
            $console: true,
            $external: true,
            $frame: true,
            $frameElement: true,
            $frames: true,
            $innerHeight: true,
            $innerWidth: true,
            $outerHeight: true,
            $outerWidth: true,
            $pageXOffset: true,
            $pageYOffset: true,
            $parent: true,
            $scrollLeft: true,
            $scrollTop: true,
            $scrollX: true,
            $scrollY: true,
            $self: true,
            $webkitIndexedDB: true,
            $webkitStorageInfo: true,
            $window: true,
          };
          var hasAutomationEqualityBug = (function () {
            /* global window */
            if (typeof window === "undefined") {
              return false;
            }
            for (var k in window) {
              try {
                if (
                  !excludedKeys["$" + k] &&
                  has.call(window, k) &&
                  window[k] !== null &&
                  typeof window[k] === "object"
                ) {
                  try {
                    equalsConstructorPrototype(window[k]);
                  } catch (e) {
                    return true;
                  }
                }
              } catch (e) {
                return true;
              }
            }
            return false;
          })();
          var equalsConstructorPrototypeIfNotBuggy = function (o) {
            /* global window */
            if (typeof window === "undefined" || !hasAutomationEqualityBug) {
              return equalsConstructorPrototype(o);
            }
            try {
              return equalsConstructorPrototype(o);
            } catch (e) {
              return false;
            }
          };

          var keysShim = function keys(object) {
            var isObject = object !== null && typeof object === "object";
            var isFunction = toStr.call(object) === "[object Function]";
            var isArguments = isArgs(object);
            var isString = isObject && toStr.call(object) === "[object String]";
            var theKeys = [];

            if (!isObject && !isFunction && !isArguments) {
              throw new TypeError("Object.keys called on a non-object");
            }

            var skipProto = hasProtoEnumBug && isFunction;
            if (isString && object.length > 0 && !has.call(object, 0)) {
              for (var i = 0; i < object.length; ++i) {
                theKeys.push(String(i));
              }
            }

            if (isArguments && object.length > 0) {
              for (var j = 0; j < object.length; ++j) {
                theKeys.push(String(j));
              }
            } else {
              for (var name in object) {
                if (
                  !(skipProto && name === "prototype") &&
                  has.call(object, name)
                ) {
                  theKeys.push(String(name));
                }
              }
            }

            if (hasDontEnumBug) {
              var skipConstructor =
                equalsConstructorPrototypeIfNotBuggy(object);

              for (var k = 0; k < dontEnums.length; ++k) {
                if (
                  !(skipConstructor && dontEnums[k] === "constructor") &&
                  has.call(object, dontEnums[k])
                ) {
                  theKeys.push(dontEnums[k]);
                }
              }
            }
            return theKeys;
          };

          keysShim.shim = function shimObjectKeys() {
            if (Object.keys) {
              var keysWorksWithArguments = (function () {
                // Safari 5.0 bug
                return (Object.keys(arguments) || "").length === 2;
              })(1, 2);
              if (!keysWorksWithArguments) {
                var originalKeys = Object.keys;
                Object.keys = function keys(object) {
                  if (isArgs(object)) {
                    return originalKeys(slice.call(object));
                  } else {
                    return originalKeys(object);
                  }
                };
              }
            } else {
              Object.keys = keysShim;
            }
            return Object.keys || keysShim;
          };

          module.exports = keysShim;
        },
        { "./isArguments": 13 },
      ],
      13: [
        function (require, module, exports) {
          "use strict";

          var toStr = Object.prototype.toString;

          module.exports = function isArguments(value) {
            var str = toStr.call(value);
            var isArgs = str === "[object Arguments]";
            if (!isArgs) {
              isArgs =
                str !== "[object Array]" &&
                value !== null &&
                typeof value === "object" &&
                typeof value.length === "number" &&
                value.length >= 0 &&
                toStr.call(value.callee) === "[object Function]";
            }
            return isArgs;
          };
        },
        {},
      ],
      14: [
        function (require, module, exports) {
          "use strict";

          var $isNaN = require("./helpers/isNaN");
          var $isFinite = require("./helpers/isFinite");

          var sign = require("./helpers/sign");
          var mod = require("./helpers/mod");

          var IsCallable = require("is-callable");
          var toPrimitive = require("es-to-primitive/es5");

          // https://es5.github.io/#x9
          var ES5 = {
            ToPrimitive: toPrimitive,

            ToBoolean: function ToBoolean(value) {
              return Boolean(value);
            },
            ToNumber: function ToNumber(value) {
              return Number(value);
            },
            ToInteger: function ToInteger(value) {
              var number = this.ToNumber(value);
              if ($isNaN(number)) {
                return 0;
              }
              if (number === 0 || !$isFinite(number)) {
                return number;
              }
              return sign(number) * Math.floor(Math.abs(number));
            },
            ToInt32: function ToInt32(x) {
              return this.ToNumber(x) >> 0;
            },
            ToUint32: function ToUint32(x) {
              return this.ToNumber(x) >>> 0;
            },
            ToUint16: function ToUint16(value) {
              var number = this.ToNumber(value);
              if ($isNaN(number) || number === 0 || !$isFinite(number)) {
                return 0;
              }
              var posInt = sign(number) * Math.floor(Math.abs(number));
              return mod(posInt, 0x10000);
            },
            ToString: function ToString(value) {
              return String(value);
            },
            ToObject: function ToObject(value) {
              this.CheckObjectCoercible(value);
              return Object(value);
            },
            CheckObjectCoercible: function CheckObjectCoercible(
              value,
              optMessage
            ) {
              /* jshint eqnull:true */
              if (value == null) {
                throw new TypeError(
                  optMessage || "Cannot call method on " + value
                );
              }
              return value;
            },
            IsCallable: IsCallable,
            SameValue: function SameValue(x, y) {
              if (x === y) {
                // 0 === -0, but they are not identical.
                if (x === 0) {
                  return 1 / x === 1 / y;
                }
                return true;
              }
              return $isNaN(x) && $isNaN(y);
            },

            // http://www.ecma-international.org/ecma-262/5.1/#sec-8
            Type: function Type(x) {
              if (x === null) {
                return "Null";
              }
              if (typeof x === "undefined") {
                return "Undefined";
              }
              if (typeof x === "function" || typeof x === "object") {
                return "Object";
              }
              if (typeof x === "number") {
                return "Number";
              }
              if (typeof x === "boolean") {
                return "Boolean";
              }
              if (typeof x === "string") {
                return "String";
              }
            },
          };

          module.exports = ES5;
        },
        {
          "./helpers/isFinite": 15,
          "./helpers/isNaN": 16,
          "./helpers/mod": 17,
          "./helpers/sign": 18,
          "es-to-primitive/es5": 19,
          "is-callable": 21,
        },
      ],
      15: [
        function (require, module, exports) {
          var $isNaN =
            Number.isNaN ||
            function (a) {
              return a !== a;
            };

          module.exports =
            Number.isFinite ||
            function (x) {
              return (
                typeof x === "number" &&
                !$isNaN(x) &&
                x !== Infinity &&
                x !== -Infinity
              );
            };
        },
        {},
      ],
      16: [
        function (require, module, exports) {
          module.exports =
            Number.isNaN ||
            function isNaN(a) {
              return a !== a;
            };
        },
        {},
      ],
      17: [
        function (require, module, exports) {
          module.exports = function mod(number, modulo) {
            var remain = number % modulo;
            return Math.floor(remain >= 0 ? remain : remain + modulo);
          };
        },
        {},
      ],
      18: [
        function (require, module, exports) {
          module.exports = function sign(number) {
            return number >= 0 ? 1 : -1;
          };
        },
        {},
      ],
      19: [
        function (require, module, exports) {
          "use strict";

          var toStr = Object.prototype.toString;

          var isPrimitive = require("./helpers/isPrimitive");

          var isCallable = require("is-callable");

          // https://es5.github.io/#x8.12
          var ES5internalSlots = {
            "[[DefaultValue]]": function (O, hint) {
              var actualHint =
                hint || (toStr.call(O) === "[object Date]" ? String : Number);

              if (actualHint === String || actualHint === Number) {
                var methods =
                  actualHint === String
                    ? ["toString", "valueOf"]
                    : ["valueOf", "toString"];
                var value, i;
                for (i = 0; i < methods.length; ++i) {
                  if (isCallable(O[methods[i]])) {
                    value = O[methods[i]]();
                    if (isPrimitive(value)) {
                      return value;
                    }
                  }
                }
                throw new TypeError("No default value");
              }
              throw new TypeError("invalid [[DefaultValue]] hint supplied");
            },
          };

          // https://es5.github.io/#x9
          module.exports = function ToPrimitive(input, PreferredType) {
            if (isPrimitive(input)) {
              return input;
            }
            return ES5internalSlots["[[DefaultValue]]"](input, PreferredType);
          };
        },
        { "./helpers/isPrimitive": 20, "is-callable": 21 },
      ],
      20: [
        function (require, module, exports) {
          module.exports = function isPrimitive(value) {
            return (
              value === null ||
              (typeof value !== "function" && typeof value !== "object")
            );
          };
        },
        {},
      ],
      21: [
        function (require, module, exports) {
          "use strict";

          var fnToStr = Function.prototype.toString;

          var constructorRegex = /^\s*class /;
          var isES6ClassFn = function isES6ClassFn(value) {
            try {
              var fnStr = fnToStr.call(value);
              var singleStripped = fnStr.replace(/\/\/.*\n/g, "");
              var multiStripped = singleStripped.replace(
                /\/\*[.\s\S]*\*\//g,
                ""
              );
              var spaceStripped = multiStripped
                .replace(/\n/gm, " ")
                .replace(/ {2}/g, " ");
              return constructorRegex.test(spaceStripped);
            } catch (e) {
              return false; // not a function
            }
          };

          var tryFunctionObject = function tryFunctionObject(value) {
            try {
              if (isES6ClassFn(value)) {
                return false;
              }
              fnToStr.call(value);
              return true;
            } catch (e) {
              return false;
            }
          };
          var toStr = Object.prototype.toString;
          var fnClass = "[object Function]";
          var genClass = "[object GeneratorFunction]";
          var hasToStringTag =
            typeof Symbol === "function" &&
            typeof Symbol.toStringTag === "symbol";

          module.exports = function isCallable(value) {
            if (!value) {
              return false;
            }
            if (typeof value !== "function" && typeof value !== "object") {
              return false;
            }
            if (hasToStringTag) {
              return tryFunctionObject(value);
            }
            if (isES6ClassFn(value)) {
              return false;
            }
            var strClass = toStr.call(value);
            return strClass === fnClass || strClass === genClass;
          };
        },
        {},
      ],
      22: [
        function (require, module, exports) {
          arguments[4][5][0].apply(exports, arguments);
        },
        { dup: 5 },
      ],
      23: [
        function (require, module, exports) {
          arguments[4][6][0].apply(exports, arguments);
        },
        { "./implementation": 22, dup: 6 },
      ],
      24: [
        function (require, module, exports) {
          "use strict";

          var implementation = require("./implementation");

          var zeroWidthSpace = "\u200b";

          module.exports = function getPolyfill() {
            if (
              String.prototype.trim &&
              zeroWidthSpace.trim() === zeroWidthSpace
            ) {
              return String.prototype.trim;
            }
            return implementation;
          };
        },
        { "./implementation": 8 },
      ],
      25: [
        function (require, module, exports) {
          "use strict";

          var define = require("define-properties");
          var getPolyfill = require("./polyfill");

          module.exports = function shimStringTrim() {
            var polyfill = getPolyfill();
            define(
              String.prototype,
              { trim: polyfill },
              {
                trim: function () {
                  return String.prototype.trim !== polyfill;
                },
              }
            );
            return polyfill;
          };
        },
        { "./polyfill": 24, "define-properties": 10 },
      ],
      26: [
        function (require, module, exports) {
          (function (process) {
            /**
             * Copyright 2014-2015, Facebook, Inc.
             * All rights reserved.
             *
             * This source code is licensed under the BSD-style license found in the
             * LICENSE file in the root directory of this source tree. An additional grant
             * of patent rights can be found in the PATENTS file in the same directory.
             */

            "use strict";

            /**
             * Similar to invariant but only logs a warning if the condition is not met.
             * This can be used to log issues in development environments in critical
             * paths. Removing the logging code for production environments will keep the
             * same logic and follow the same code paths.
             */

            var warning = function () {};

            if (process.env.NODE_ENV !== "production") {
              warning = function (condition, format, args) {
                var len = arguments.length;
                args = new Array(len > 2 ? len - 2 : 0);
                for (var key = 2; key < len; key++) {
                  args[key - 2] = arguments[key];
                }
                if (format === undefined) {
                  throw new Error(
                    "`warning(condition, format, ...args)` requires a warning " +
                      "message argument"
                  );
                }

                if (format.length < 10 || /^[s\W]*$/.test(format)) {
                  throw new Error(
                    "The warning format should be able to uniquely identify this " +
                      "warning. Please, use a more descriptive format than: " +
                      format
                  );
                }

                if (!condition) {
                  var argIndex = 0;
                  var message =
                    "Warning: " +
                    format.replace(/%s/g, function () {
                      return args[argIndex++];
                    });
                  if (typeof console !== "undefined") {
                    console.error(message);
                  }
                  try {
                    // This error was thrown as a convenience so that you can use this stack
                    // to find the callsite that caused this warning to fire.
                    throw new Error(message);
                  } catch (x) {}
                }
              };
            }

            module.exports = warning;
          }).call(this, require("_process"));
        },
        { _process: 1 },
      ],
    },
    {},
    [2]
  )(2);
});
